import { __rest, __assign } from 'tslib';
import React, { useContext, Children } from 'react';
import cn from 'classnames';
import { Text } from '../../typography/esm';
import { isItem } from './utils.js';

var styles$1 = {"item":"list__item_1oa7j","reversed":"list__reversed_1oa7j","unorderedItem":"list__unorderedItem_1oa7j","slot":"list__slot_1oa7j","defaultColor":"list__defaultColor_1oa7j","disc":"list__disc_1oa7j","caption":"list__caption_1oa7j"};
require('./components/item/index.css');

var Item = function (_a) {
    var _b, _c;
    var caption = _a.caption, children = _a.children, className = _a.className, markerClassName = _a.markerClassName;
    var _d = useContext(ListContext), orderedList = _d.orderedList, markerType = _d.markerType, colorMarker = _d.colorMarker, reversed = _d.reversed, _e = _d.index, index = _e === void 0 ? 0 : _e, _f = _d.start, start = _f === void 0 ? 0 : _f;
    var markerLowerAlpha = markerType === 'lower-alpha';
    var itemClassNames = cn(styles$1.item, className, (_b = {},
        _b[styles$1.unorderedItem] = markerLowerAlpha,
        _b[styles$1.reversed] = reversed,
        _b));
    var isDisc = markerType === '•';
    var count = start === 0 ? index + 1 : start + index;
    var marker = orderedList || markerType === 'decimal' ? "".concat(count, ".") : markerType;
    return (React.createElement("li", { className: cn(itemClassNames) },
        !markerLowerAlpha && (React.createElement(Text, { tag: 'div', color: colorMarker, monospaceNumbers: true, view: 'primary-medium', className: cn(styles$1.slot, markerClassName, (_c = {},
                _c[styles$1.disc] = isDisc && !orderedList,
                _c[styles$1.defaultColor] = !colorMarker,
                _c)) }, marker)),
        React.createElement("div", null,
            React.createElement(Text, { tag: 'div', view: 'primary-medium' }, children),
            caption && (React.createElement(Text, { tag: 'div', view: 'primary-small', color: 'secondary', className: styles$1.caption }, caption)))));
};
Item.displayName = 'ListItem';

var styles = {"list":"list__list_15vdr","lowerAlpha":"list__lowerAlpha_15vdr","decimal":"list__decimal_15vdr","reversed":"list__reversed_15vdr"};
require('./index.css');

var ListContext = React.createContext({});
var ListComponent = function (_a) {
    var _b;
    var _c = _a.tag, tag = _c === void 0 ? 'ul' : _c, marker = _a.marker, className = _a.className, dataTestId = _a.dataTestId, colorMarker = _a.colorMarker, children = _a.children, reversed = _a.reversed, start = _a.start, restProps = __rest(_a, ["tag", "marker", "className", "dataTestId", "colorMarker", "children", "reversed", "start"]);
    var markerType = marker || (tag === 'ul' ? '—' : 'decimal');
    var alphaMarker = markerType === 'lower-alpha';
    var decimalMarker = markerType === 'decimal';
    var Component = tag === 'ul' || alphaMarker ? 'ul' : 'ol';
    var orderedList = Component === 'ol';
    var listClassNames = cn(styles.list, (_b = {},
        _b[styles.lowerAlpha] = alphaMarker,
        _b[styles.decimal] = decimalMarker,
        _b[styles.reversed] = reversed,
        _b), className);
    /* eslint-disable react/jsx-no-constructed-context-values */
    return (React.createElement(Component, __assign({ className: listClassNames, "data-test-id": dataTestId }, restProps), Children.map(children, function (child, index) { return (React.createElement(ListContext.Provider, { value: { orderedList: orderedList, markerType: markerType, colorMarker: colorMarker, reversed: reversed, index: index, start: start } }, isItem(child) ? child : React.createElement(Item, null, child))); })));
};
var List = Object.assign(ListComponent, {
    Item: Item,
});

export { Item as I, ListContext as L, List as a };
